import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/book', request)
}

export {post}
